/* tslint:disable */
import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
} from "@angular/core";
/**
 * @Bhushan services for initializing categoires and productitems list
 */
import { NaviFreshMartService } from "../../../shared/services/navi-fresh-mart.service";
import { address } from "../../classes/address";
import { GooglePlaceDirective } from "ngx-google-places-autocomplete";
import { Address } from "ngx-google-places-autocomplete/objects/address";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {} from "googlemaps";
@Component({
  selector: "app-location",
  templateUrl: "./location.component.html",
  styleUrls: ["./location.component.scss"]
})
export class LocationComponent implements OnInit, AfterViewInit {
  loadingAction: boolean = false;
  detectLocationAction: boolean = false;
  @Input("isLocation") isLocation: boolean;
  @Input("isLocation2") isLocation2: boolean;
  @Input("isCart") isCart: boolean;
  @ViewChild("myDiv") myDiv: ElementRef<HTMLElement>;
  geocoder=new google.maps.Geocoder();
  //latest changes
  addressList: address[] = [];
  user: any = {};
  isAddressSelected: boolean = false;
  options : any = { 
    fields: ["address_component", "formatted_address", "place_id"]
  };
  selectedAddress: address = {};
  checkedAddress: address = {};
  public addressType: string = "0";
  divLocation = "Set Location";
  currentLocation = "Not able To Detect Your Location!";
   SUBLOCALITY = 'sublocality';
   LOCALITY = 'locality';
   POSTAL_CODE = 'postal_code';
   savedAddressType = "";
  /** for address modal */
  selectedValue: string = "Title";
  @ViewChild("placesRef", { static: false }) placesRef: GooglePlaceDirective;
  public handleAddressChange(addressLocation: Address) {
    // console.log("place: ",this.placesRef.place);
    // Do some stuff
    console.log("address: ", addressLocation);
    this.savedAddressType = "";
    this.divLocation = addressLocation.formatted_address;
    localStorage.setItem("currentLocation",this.divLocation);
    
  }
  constructor(private modalService: NgbModal, private productItemsService: NaviFreshMartService) {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.divLocation = localStorage.getItem("currentLocation");
    if(!this.divLocation){
        this.detectLocation();
    }
    console.log("user:", this.user);
    if (this.user) {
      /**
       * address list
       */
      let addressPayload: address = {
        accountId: this.user?.accountId,
        addressId: 0,
        addressType: "",
        city: "",
        defaultAddress: false,
        doorNo: "",
        landmark: "",
        locality: "",
        pincode: "",
        state: "",
      };
      this.productItemsService.getAddress(addressPayload).subscribe((data) => {
        this.addressList = data?.addressList;
        console.log("this.addressList", this.addressList);
        if (this.addressList && !Array.isArray(this.addressList)) {
          this.addressList = [this.addressList];
          localStorage.setItem("addressList", JSON.stringify(this.addressList));
        } else {
          localStorage.setItem("addressList", JSON.stringify(this.addressList));
        }
      });

      /*** end */
    }
  }
  ngAfterViewInit(): void {}
  ngOnInit(): void {}

  detectLocation() {
    this.loadingAction = true;
    if ('geolocation' in navigator) {
      const options = {
        enableHighAccuracy: true, // Request high-accuracy location data
      };
    window.navigator.geolocation.getCurrentPosition(
      (response) => {
        console.log("current geo location :", response);
        this.loadingAction = false;
        this.detectLocationAction = false;
        let el: HTMLElement = this.myDiv.nativeElement;
        el.click();
        this.geocodeLatLng(response.coords.latitude,response.coords.longitude);
      },
      (error) => {
        console.log("error", error);
        this.loadingAction = false;
        this.detectLocationAction = false;
      },
      options
    );
    // setTimeout(() => {
    //   this.loadingAction = false;
    //   this.detectLocationAction = true;
    // }, 1000)
  }
}
  openAddressModel() {
    this.isAddressSelected = true;
    this.selectedAddress = {};
  }
  closeAddressModal() {
    this.isAddressSelected = false;
    this.selectedAddress = {};
  }
  changeDropdownName(value: string) {
    this.selectedValue = value;
  }
  submitAddress() {
    this.selectedAddress.accountId = this.user?.accountId;
    this.selectedAddress.addressType = this.addressType;
    this.selectedAddress.defaultAddress = false;
    if (this.selectedAddress.addressId !== 0) {
      console.log(this.selectedAddress.addressId);
    } else {
      this.selectedAddress.addressId = 0;
    }
    console.log(this.selectedAddress);
    this.productItemsService
      .postAddress(this.selectedAddress)
      .subscribe((data) => {
        console.log("Posted Address:", data);
        this.closeAddressModal();
        this.selectedAddress = {};
        /**
         * address list
         */
        let addressPayload: address = {
          accountId: this.user?.accountId,
          addressId: 0,
          addressType: "",
          city: "",
          defaultAddress: false,
          doorNo: "",
          landmark: "",
          locality: "",
          pincode: "",
          state: "",
        };
        this.productItemsService
          .getAddress(addressPayload)
          .subscribe((data) => {
            this.addressList = data?.addressList;
            console.log("this.addressList", this.addressList);
            if (this.addressList && !Array.isArray(this.addressList)) {
              this.addressList = [this.addressList];
              localStorage.setItem(
                "addressList",
                JSON.stringify(this.addressList)
              );
            } else {
              localStorage.setItem(
                "addressList",
                JSON.stringify(this.addressList)
              );
            }
          });
      });
  }
  onProfitSelectionChange(myaddress: address, i: any) {
    // console.log(i);

    this.checkedAddress = myaddress;
  }
  geocodeLatLng(latStr, longStr) {
    console.log("lat ",latStr,"long ",longStr);
    const latlng = {
      lat: parseFloat(latStr),
      lng: parseFloat(longStr),
    };
    this.geocoder.geocode(
      { location: latlng },
      (
        results: google.maps.GeocoderResult[],
        status: google.maps.GeocoderStatus
      ) => {
        if (status === "OK") {
          if (results[0]) {
            const addressComponents = results[0].address_components;
            console.log(addressComponents);
            /**
             * filteer the address components
             */
            let formattedAddress = addressComponents.filter((addressComponent)=>{
                return   addressComponent.types.find((typeData)=> typeData=== this.SUBLOCALITY || typeData=== this.LOCALITY || typeData=== this.POSTAL_CODE);
            });
            console.log(formattedAddress);
            let finalAddress ="";
            /*formattedAddress.forEach((element)=>{
               
                finalAddress = finalAddress.concat(element.short_name,",");
            })*/
           //finalAddress = finalAddress.slice(0,finalAddress.length-1);
           finalAddress = formattedAddress[formattedAddress.length-1].short_name;
            console.log("finalAddress",finalAddress);
            this.savedAddressType = "";
            this.divLocation = finalAddress || results[0].formatted_address;
            localStorage.setItem('currentLocation',this.divLocation);
            console.log("location address: ",this.divLocation);
            let el: HTMLElement = this.myDiv.nativeElement;
            el.click();
          } else {
            window.alert("No results found");
          }
        } else {
          window.alert("Geocoder failed due to: " + status);
        }
      }
    );
  }

  updateLocation(address: any) {
    this.savedAddressType =  address.addressType;
    this.divLocation =  address.addressType;
    let el: HTMLElement = this.myDiv.nativeElement;
            el.click();
  }
  
}
